/**
 * The internal dependencies.
 */
import IconHelp from '../../assets/images/temp/ico-help.png';
import IconHelpActive from '../../assets/images/temp/ico-help-white.png';
import IconGuide from '../../assets/images/temp/ico-book.png';
import IconReport from '../../assets/images/temp/ico-camera.png';

export default [
    {
        id: 'help',
        disabled: false,
        color: '#43abf3',
        activeColor: '#fff',
        background: '#4a4a50',
        activeBackground: '#43abf3',
        label: 'Hilfe',
        icon: IconHelp,
        activeIcon: IconHelpActive,
    },
    {
        id: 'guide',
        disabled: false,
        color: '#4a4a50',
        activeColor: '#fff',
        background: '#d9d7d7',
        activeBackground: '#43abf3',
        label: 'Handbuch',
        icon: IconGuide,
        activeIcon: IconGuide,
    },
    {
        id: 'report',
        disabled: false,
        color: '#fff',
        background: '#ea3434',
        label: 'Fehler melden',
        icon: IconReport,
    },
];



// WEBPACK FOOTER //
// ./src/assets/data/working-task-tabs.js